"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PIN_ICON_WIDTH = exports.PIN_ICON_WIDTH = 24;
var PIN_ICON_HEIGHT = exports.PIN_ICON_HEIGHT = 28;
var DEFAULT_METERS = exports.DEFAULT_METERS = 3000;
var DEFAULT_KILOMETERS = exports.DEFAULT_KILOMETERS = DEFAULT_METERS / 1000;